<footer>
    <p>
        Clipping de Agente de Prensa versión <strong>{{semVer}}</strong> ({{buildDate}})
    </p>
    <p>
        © 2019-{{year}}
        <a target="_blank" href="https://makingconnexion.com/">Making Connexion</a> y
        <a target="_blank" href="https://contentmedia.pe/">Content Media</a>
    </p>
</footer>
